import { authStore } from "@bebit/auth";
import { DeviceCategory } from "@bebit/types";
import { useSessionStorage, useLocalStorage } from "@vueuse/core";
import { computed, ComputedRef } from "vue";

type UserId = string;

type DeviceCategoryLocalStorage = Map<UserId, DeviceCategory>;
type DeviceCategorySessionStorage = Map<UserId, DeviceCategory | undefined>;

export const STORAGE_KEY = "DEVICE_CATEGORY";

export function useDeviceCategoryFromStorages() {
  const local = useLocalStorage<DeviceCategoryLocalStorage>(STORAGE_KEY, new Map<UserId, DeviceCategory>());
  const session = useSessionStorage<DeviceCategorySessionStorage>(
    STORAGE_KEY,
    new Map<UserId, DeviceCategory | undefined>()
  );

  const saveDeviceCategoryToStorages = (newDeviceCategory: DeviceCategory) => {
    session.value.set(getCurrentUserId(), newDeviceCategory);
    local.value.set(getCurrentUserId(), newDeviceCategory);
  };

  const deviceCategoryFromStorages: ComputedRef<DeviceCategory | undefined> = computed(() => {
    if (session.value !== undefined) {
      const deviceCategoryStoredInSession = session.value.get(getCurrentUserId());
      if (deviceCategoryStoredInSession) return deviceCategoryStoredInSession;
    }
    return local.value.get(getCurrentUserId());
  });

  return { deviceCategoryFromStorages, saveDeviceCategoryToStorages };
}

function getCurrentUserId(): string {
  return authStore.user ? authStore.user?.id.toString() : "";
}
